import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { MobileCallBar } from "./components/site/MobileCallBar";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Analytics } from "./components/site/Analytics";
import Home from "./pages/Home";
import ContentPage from "./pages/ContentPage";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import { PAGES } from "./data/pages";
import { ZONE_PAGES } from "./data/zones";
import { CITY_PAGES } from "./data/cityPages";
import { SPECIES_PAGES } from "./data/species";
import { ARTICLES, CONSEILS_HUB } from "./data/conseils";

const CONTENT = [...Object.values(PAGES), ...Object.values(SPECIES_PAGES), CONSEILS_HUB, ...Object.values(ARTICLES)];
const OLD_ZONES = ["gironde", "bordeaux", "libourne", "bassin-arcachon", "medoc"];

const Layout = () => (
  <>
    <SmoothScroll />
    <Header />
    <Outlet />
    <Footer />
    <MobileCallBar />
    <Analytics />
  </>
);

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            {CONTENT.map(p => <Route key={p.path} path={p.path} element={<ContentPage page={p} />} />)}
            {Object.values(ZONE_PAGES).map(p => <Route key={p.path} path={p.path} element={<ContentPage page={p} zoneName={p.name} />} />)}
            {CITY_PAGES.map(p => <Route key={p.path} path={p.path} element={<ContentPage page={p} zoneName={p.name} />} />)}
            {OLD_ZONES.map(s => <Route key={s} path={`/secteurs/${s}`} element={<Navigate to={`/traitement-moustique-${s}`} replace />} />)}
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal kind="mentions" />} />
            <Route path="/politique-de-confidentialite" element={<Legal kind="privacy" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
